import { render, staticRenderFns } from "./MyProjectsIntro.vue?vue&type=template&id=4b89d600&scoped=true"
import script from "./MyProjectsIntro.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyProjectsIntro.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./MyProjectsIntro.vue?vue&type=style&index=0&id=4b89d600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b89d600",
  null
  
)

export default component.exports